var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card-text',[_c('v-chip',{staticClass:"primary primary--text",attrs:{"outline":"","small":""}},[_vm._v(_vm._s(_vm.$t(("service.meta." + (_vm.service.service_type)))))]),_vm._v(" "),_vm._l((_vm.options),function(option){return _c('v-chip',{key:option.key,staticClass:"secondary secondary--text",attrs:{"outline":"","small":""}},[_vm._v("\n    "+_vm._s(_vm.$t(("service.meta.options." + (option.key)), { value: option.value }))+"\n  ")])})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5eac2f68","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/service/Meta.vue
// module id = null
// module chunks = 